<ion-card target="_blank" [href]="[recommendation.link]">
  <div class="card-image">
    <img loading="lazy" [src]="recommendation.image" [alt]="recommendation.title" />
  </div>
  <div class="card-caption">
    <h6 class="title">{{ recommendation.title }}</h6>
  </div>
</ion-card>